import { createSlice, type PayloadAction } from "@reduxjs/toolkit";
import type { ViewCustomer } from "collins-js-sdk";
import type { RootState } from "../store";

export type CustomerState = {
  selectedCustomer?: ViewCustomer;
};

export const initialCustomerState: CustomerState = {
  selectedCustomer: undefined
};

const customerSlice = createSlice({
  name: "customer",
  initialState: initialCustomerState,
  reducers: {
    selectedCustomerChanged: (
      state,
      action: PayloadAction<ViewCustomer | undefined>
    ) => {
      state.selectedCustomer = action.payload;
    }
  }
});

export const { selectedCustomerChanged } = customerSlice.actions;

export const selectSelectedCustomer = (
  state: RootState
): ViewCustomer | undefined => state.customer.selectedCustomer;

export const customerReducer = customerSlice.reducer;
export default customerReducer;
